import { createUserInteraction } from '../utils';
import { trackEvent } from 'lib/ui-analytics';

import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';
import { isLoyaltyId } from 'contexts/CruiseSearchContext/utils/targetedOffers';

const { TARGETED_OFFERS } = TRACKING_INTERACTION;

export const utagMyOffersFilter = (targetedOffers, loyaltyIDOrEmailLogin) => {
  if (!Array.isArray(targetedOffers) || !loyaltyIDOrEmailLogin) return;

  const isCAS = isLoyaltyId(loyaltyIDOrEmailLogin);
  const hasTargetedOffers = targetedOffers.length > 0;
  let interactionType = {};
  let extraParams = {};

  if (hasTargetedOffers) {
    interactionType = {
      eventType: TRACKING_ACTION.INTERACTIONS,
      interaction: isCAS
        ? TARGETED_OFFERS.USER_IDENTIFIED_CAS
        : TARGETED_OFFERS.USER_IDENTIFIED_EMAIL,
    };
    extraParams = {
      ...(isCAS && { loyaltyNum: loyaltyIDOrEmailLogin }),
      ...(!isCAS && { email: loyaltyIDOrEmailLogin }),
    };
  } else {
    interactionType = {
      eventType: TRACKING_ACTION.INTERACTIONS,
      interaction: TARGETED_OFFERS.FILTER_NORESULT,
    };
  }

  const interaction = createUserInteraction(interactionType, extraParams);
  trackEvent(interaction);
};
